/**
 * Geocoding utilities using OpenStreetMap Nominatim — free, no API key.
 * No custom headers are set (browsers block User-Agent override via fetch).
 * The browser's own User-Agent is sent automatically, which Nominatim accepts.
 */

const NOMINATIM = 'https://nominatim.openstreetmap.org';

/**
 * Geocode an address string → { lat, lng, display_name }
 */
export const mapplsGeocode = async (address) => {
  try {
    const res = await fetch(
      `${NOMINATIM}/search?q=${encodeURIComponent(address)}&format=json&limit=1&countrycodes=in`
    );
    if (!res.ok) return null;
    const data = await res.json();
    if (!data?.length) return null;
    return {
      lat: parseFloat(data[0].lat),
      lng: parseFloat(data[0].lon),
      display_name: data[0].display_name,
    };
  } catch {
    return null;
  }
};

/**
 * Autosuggest: text query → array of place suggestions
 * Each item has: placeName, placeAddress, latitude, longitude
 */
export const mapplsAutosuggest = async (query) => {
  if (!query || query.length < 3) return [];
  try {
    const res = await fetch(
      `${NOMINATIM}/search?q=${encodeURIComponent(query)}&format=json&limit=7&countrycodes=in&addressdetails=1`
    );
    if (!res.ok) return [];
    const data = await res.json();
    return data.map(item => ({
      placeName: item.name || item.display_name.split(',')[0].trim(),
      placeAddress: item.display_name,
      latitude: item.lat,
      longitude: item.lon,
      eLoc: item.place_id?.toString(),
    }));
  } catch {
    return [];
  }
};

/**
 * Reverse geocode: lat/lng → formatted address string
 */
export const mapplsReverseGeocode = async (lat, lng) => {
  try {
    const res = await fetch(
      `${NOMINATIM}/reverse?lat=${lat}&lon=${lng}&format=json`
    );
    if (!res.ok) return '';
    const data = await res.json();
    return data?.display_name || '';
  } catch {
    return '';
  }
};

/**
 * getCoordinatesFromELoc — reads lat/lng from a suggestion object directly.
 */
export const getCoordinatesFromELoc = (suggestion) => {
  if (!suggestion?.latitude) return null;
  return {
    lat: parseFloat(suggestion.latitude),
    lng: parseFloat(suggestion.longitude),
  };
};
